define('views/accounts/linknewcard/linknewcard',[
    'backbone',
    'text!views/accounts/linknewcard/linknewcard.html',
    'views/_base/baseview',
    'models/validator/cardnumberlinked',
    'models/validator/month',
    'models/validator/year',
    'models/validator/zipcode',
    'models/validator/cardlinkednickname',
    'models/securecontent/securecontent',
    'models/order/product/product',
    'views/accounts/getdebitcard',
], function(Backbone, Template, BaseView, LinkedCardValidator, MonthValidator, YearValidator, ZipcodeValidator, LinkedCardNicknameValidator, SecureContent, OrderProduct, GetDebitCardView){
    'use strict';

    return BaseView.extend({
        id       : 'link-card',
        tagName  : 'section',
        template : _.template(Template),
        isRender : true,
        needsAuth: true,
        
        touched: { // Keep track of whether expiration month/year has been interacted with, for intuitive, instant validation.
            expMonth: false,
            expYear: false
        },

        events: {
            'change .js-validate-on-change':    'validateByEvent',
            'submit #linked-card-form'     :    'submitForm'
        },

        initialize: function(options){
            options = options || {};            
            this.elementName = options.elementName;
            this.isRegistrationFlow = options.isRegistrationFlow;
            this.cardType = null;
            this.MGGD = options.MGGD;
            this.MGID = options.MGID;

            _.bindAll(this, 'postContentCallback');
            this.on('changed:cardType', this.updateCardTerms, this);
            
            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.checkFinRegStatus(function(){

                that.$el.html(that.template());

                that.elInputExpMonth        = that.$('#expiration-month');
                that.elInputExpYear         = that.$('#expiration-year');
                that.elCardTermsWrap        = that.$('.js-card-terms-wrap');
                that.elCheckboxCardTerms    = that.$('#card-terms');
                that.elCardTermsContent     = that.$('.js-card-terms-content');
                that.elSubmitBtn            = that.$('.js-link-card-btn');

                that.addExpirationYears();

                that.updateCardTerms();

            });

            return this;
        },

        checkFinRegStatus: function(callback){
            $.ajax({
                async: false,
                type: 'GET',
                url: pf.authURL + '/Token/CheckFin',
                contentType: 'application/json',
                success: function(resp, model){
                    if(callback){
                        callback(resp);
                    }
                },
                error: function(resp, model){
                    if(callback){
                        callback(resp);
                    }
                }
            });
        },

        addExpirationYears: function(){
            var thisYear = new Date().getFullYear();
            for (var i = 0; i < 20; i++) {
                var optionYear = thisYear + i;
                this.elInputExpYear.append(this.createSelectOption(optionYear, optionYear));
            }
        },

        createSelectOption: function(val, content) {
            return '<option value=' + val + '>' + content + '</option>';
        },

        setCardType: function(value){
            if(value != this.cardType){
                this.cardType = value;
                // this.trigger('changed:cardType');
                // Trigger is not working correctly so call the function directly
                this.updateCardTerms();
            }
        },

        updateCardTerms: function(){
            // Uncheck checkbox whenever card terms change
            this.elCheckboxCardTerms.prop('checked', false);
            
            // Only show the checkbox if a valid card number has been entered
            if(this.cardType){
                this.elCardTermsWrap.removeClass('hidden');
            } else {
                this.elCardTermsWrap.addClass('hidden');
            }

            // Determine checkbox text
            var checkboxContent = '';
            switch(this.cardType) {
                case enums.networkSources.Visa:
                    checkboxContent = pf.getContent('disclosure.visaOptIn');
                    break;
                case enums.networkSources.MasterCard:
                    checkboxContent = pf.getContent('disclosure.mastercardOptIn');
                    break;
            }
            this.elCardTermsContent.html(checkboxContent);
        },

        validateByEvent: function(e) {
            switch(e.target.id) {
                case 'card-number':
                    this.validateCardNumber();
                    break;
                case 'card-cvv':
                    this.validateCardCvv();
                    break;
                case 'expiration-month':
                    this.touched.expMonth = true;
                    this.validateExpDate();
                    break;
                case 'expiration-year':
                    this.touched.expYear = true;
                    this.validateExpDate();
                    break;
                case 'zipcode':
                    this.validateZipcode();
                    break;
                case 'card-nickname':
                    this.validateCardNickname();
                    break;
                case 'pf-terms':
                    this.validatePayForwardTerms();
                    break;
                case 'card-terms':
                    this.validateCardTerms();
                    break;
            }
        },

        submitForm: function(e) {
            if(e && e.preventDefault) { e.preventDefault();}
            if(e && e.stopPropagation) { e.stopPropagation();}

            this.addButtonSpinner();

            this.touched.expMonth = true;
            this.touched.expYear = true;

            var formIsValid = true;

            var card_cvv = this.validateCardCvv();
            if(card_cvv == false){
                formIsValid = false;
            }

            var cardValidator = this.validateCardNumber();
            if( !cardValidator.isValid() ){
                formIsValid = false;
            }

            var expDateObj = this.validateExpDate();
            if( !expDateObj.dateIsValid ){
                formIsValid = false;
            }

            var zipcodeValidator = this.validateZipcode();
            if( !zipcodeValidator.isValid() ){
                formIsValid = false;
            }

            var cardNicknameValidator = this.validateCardNickname();
            if( !cardNicknameValidator.isValid() && !cardNicknameValidator.isEmpty() ){
                formIsValid = false;
            }

            var payForwardTermsAccepted = this.validatePayForwardTerms();
            if( !payForwardTermsAccepted ){
                formIsValid = false;
            }

            var cardTermsAccepted = this.validateCardTerms();
            if( !cardTermsAccepted ){
                formIsValid = false;
            }
            
            if(formIsValid){
                // SUBMIT TO API
                var requestBody = {
                    'data': {
                        'cardNum': encrypt( cardValidator.get('value') ),
                        'cvv': encrypt(card_cvv),
                        'expMonth': expDateObj.monthValidator.get('value'),
                        'expYear': expDateObj.yearValidator.get('value'),
                        'billingZip': zipcodeValidator.get('value'),
                        'nickname': cardNicknameValidator.get('value'),
                        'agreePFAgreement': payForwardTermsAccepted,
                        'agreeTOS': cardTermsAccepted
                    },
                    'origin': window.location.href,
                    'userGUID': pf.session.get('UserGUID')
                };

                var sc = new SecureContent({ 'requestBody': requestBody });
                return sc.postContent(this.postContentCallback);
            } else {
                this.removeButtonSpinner();
            }
        },

        postContentCallback: function(err, body){
            if(err){
                this.removeButtonSpinner();

                var errorMessage;
                if(err.status == 409){
                    errorMessage = 'This card is already registered.';
                } else {
                    errorMessage = 'Oops, something went wrong.  Please try again.';
                }
                jAlert(errorMessage);
            } else {
                jAlert( 'Your card will be able to earn rewards in approximately 1 hour.', ['Success!'] );

                if(this.MGGD && this.MGID){
                    pf.navigate('merchants/groups/' + this.MGGD + '/ecard/' + this.MGID);
                } else if(this.isRegistrationFlow == true){
                    // show GPR pitch with success message
                    var debitCardView = new GetDebitCardView({
                        elementName: '#mainRegion',
                        showLinkedCardSuccess: true,
                        isModal: false
                    });
                    pf.show(debitCardView);
                } else {
                    pf.navigate('wallet');
                }
            }
        },

        addButtonSpinner: function(){
            this.elSubmitBtn.addClass('btn-showSpinner').attr('disabled', true);
        },

        removeButtonSpinner: function(){
            this.elSubmitBtn.removeClass('btn-showSpinner').attr('disabled', false);
        },


// ------------------------------------------
// Indivitual Validators
// ------------------------------------------

        validateCardNumber: function(){
            var elInput = this.$('#card-number'),
                elInputMsg = this.$('#card-number-msg'),
                validator = new LinkedCardValidator;

            validator.validate( elInput.val().trim() );

            if( validator.isValid() ){
                feedbackValid(elInput, elInputMsg);
            } else {
                feedbackError(elInput, elInputMsg, pf.getContent('validation.cardNumberLinked'));
            }
            this.setCardType( validator.get('cardType') );
            return validator;
        },

        validateCardCvv: function(){

            var input = this.$('#card-cvv'),
                input_message = this.$('#card-cvv-msg');

            if(input.val() && input.val().length >= 3){
                feedbackValid(input, input_message);
                return input.val();
            } else {
                feedbackError(input, input_message, pf.getContent('validation.cardNumberCvv'));
                return false;
            }

        },

        validateExpDate: function(){
            var elInputMonth = this.elInputExpMonth,
                elInputYear = this.elInputExpYear,
                elInputMsg = this.$('#expiration-msg'),
                monthValidator = new MonthValidator,
                yearValidator = new YearValidator;

            monthValidator.validate( elInputMonth.val() );
            yearValidator.validate( elInputYear.val() );

            var month = monthValidator.getIntValue(),
                year = yearValidator.getIntValue(),
                now = new Date();

            var monthIsValid;
            if(this.touched.expMonth){
                if( !monthValidator.isValid() ){
                    styleInputError(elInputMonth);
                    monthIsValid = false;
                } else if( year == now.getFullYear() && month < (now.getMonth() + 1) ){
                    // Date chosen is in the current year, but in the past, thus invalid
                    styleInputError(elInputMonth);
                    monthIsValid = false;
                } else { // Valid
                    styleInputValid(elInputMonth);
                    monthIsValid = true;
                }
            }

            var yearIsValid;
            if(this.touched.expYear){
                if( !yearValidator.isValid() ){
                    styleInputError(elInputYear);
                    yearIsValid = false;
                } else { // Valid
                    styleInputValid(elInputYear);
                    yearIsValid = true;
                }
            }

            var isValid = (monthIsValid && yearIsValid); // BOOLEAN
            // Only add error message if both Month and Year have been interacted with.
            if( !isValid && this.touched.expMonth && this.touched.expYear ){
                addErrorMsg(elInputMsg, pf.getContent('validation.cardExpDate'));
            } else {
                removeErrorMsg(elInputMsg);
            }

            var result = {
                monthValidator: monthValidator,
                yearValidator: yearValidator,
                dateIsValid: isValid
            }
            return result;
        },

        validateZipcode: function(){
            var elInput = this.$('#zipcode'),
                elInputMsg = this.$('#zipcode-msg'),
                validator = new ZipcodeValidator;

            validator.validate( elInput.val().trim() );

            if( validator.isValid() ){
                feedbackValid(elInput, elInputMsg);
            } else {
                feedbackError(elInput, elInputMsg, pf.getContent('validation.zipCode.invalid'));
            }
            return validator;
        },

        validateCardNickname: function(){
            var elInput = this.$('#card-nickname'),
                elInputMsg = this.$('#card-nickname-msg'),
                validator = new LinkedCardNicknameValidator;

            validator.validate( elInput.val().trim() );

            if( validator.isEmpty() ){
                feedbackClear(elInput, elInputMsg);
            } else if( validator.isValid() ){
                feedbackValid(elInput, elInputMsg);
            } else {
                feedbackError(elInput, elInputMsg, pf.getContent('validation.cardNicknameLinked'));
            }
            return validator;
        },

        validatePayForwardTerms: function(){
            var elInput     = this.$('#pf-terms'),
                elInputMsg  = this.$('#pf-terms-msg'),
                isValid = true;

            if(elInput.prop('checked')){
                feedbackValid(elInput, elInputMsg);
            } else {
                isValid = false;
                feedbackError(elInput, elInputMsg, pf.getContent('validation.acceptAccountHolderAgreement'));
            }
            return isValid;
        },

        validateCardTerms: function(){
            var elInput = this.elCheckboxCardTerms,
                elInputMsg = this.$('#card-terms-msg'),
                isValid = true;

            if(elInput.prop('checked')){
                feedbackValid(elInput, elInputMsg);
            } else {
                feedbackError(elInput, elInputMsg, pf.getContent('validation.acceptCardTerms'));
                isValid = false;
            }
            return isValid;
        },

        close: function(){ 
            this.off('changed:cardType', this.updateCardTerms);
        }
    });
});


